import { createSelector } from 'reselect';

//Tots els usuari
const selectorTotsUsuaris = state => state.usuari.tots;


/**
 * Retorna els usuaris actius de l'estació que esta al store
 * @param {*} state
 * @return {array}
 */
const observadorsActius = (historicObservadors) => {
    if (!historicObservadors) return null;

    const observadorsActius = historicObservadors.filter((usuari) => {
        return (typeof usuari.dataBaixa === 'undefined' ||usuari.dataBaixa === null );
    });

    return observadorsActius;
};
const historicObservadors = state => state.estacio.formulari.dades.historicObservadors.originals;

const observadorsActiusSelector = createSelector(
    historicObservadors,

    observadorsActius
);

/**
 * Retorna la informació dels observadors especificats al parametre observadors
 * @param {object} tots objecte que esta index amb idUsuari
 * @param {*} observadors observadors dels quals es vol buscar informació.
 * @return {array}
 */
const obtenirUsuarisActius = (tots, observadors) => {
    let usuaris = [];

    if (observadors && tots) {
        observadors.forEach((observador) => {
            const usuari = tots[observador.idUsuari];

            if (usuari) {
                usuaris.push(usuari);
            }
        });
    }

    return usuaris;
};

/**
 * Selector que a partir de la llista de historics de observadors, retorna una llista dels
 * observadors actius amb les seves dades d'usuari.
 * La llista de historics d'observadors, només conté el id del observador, per aquest motiu s'ha
 * de buscar tota la informació del usuari.
 * NOTA: el parametre "observadorsActiusSelector()" ha de ser un altre selector per tal que es faci
 * el memoized, no es pot possar com parametre una funcio que no sigui un altre selector.
 */
const selector = createSelector(
    selectorTotsUsuaris,
    observadorsActiusSelector,

    obtenirUsuarisActius
);
export default selector;


// WEBPACK FOOTER //
// ./src/selectors/selector_observadors_actius_per_estacio.js